<template>
  <v-dialog :value="type === 'user'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển người phụ trách
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Người phụ trách"
              >
                <common-select-user
                  v-model="userId"
                  :items="users"
                  color="primary"
                  placeholder="Tìm kiếm người phụ trách theo tên"
                  item-text="fullName"
                  item-value="id"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu Lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from "@/repositories/RepositoryFactory";
const ShortLinkRepository = RepositoryFactory.get("short_link");
export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    contacts: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      userId: '',
    };
  },
  methods: {
    hideModal() {
      this.$emit('close')
    },
    async saveChange() {
      const shortLinkIds = []
      this.contacts.forEach(element => {
        shortLinkIds.push(element._id)
      });

      const params = { shortLinkIds: shortLinkIds, newUserId: this.userId }
      try {
        const loading = this.$loading.show();
        const response = await ShortLinkRepository.updateUser(params);
        loading.hide();
        if (response.error) {
        this.errorMessage = _.get(response, 'message', '');

        return;
        }
        this.$swal({
          title: 'Chuyển người phụ trách thành công !!!',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          this.hideModal();
          this.$emit('complete')
        });
      } catch (error) {}
    }
  }
};
</script>
